import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { FilePage } from './FilePage';
export function GuaranteeFile() {
  return <FilePage id="garantia" number="06" label="Garantía" data-id="element-187" data-mp="y89mstb32bkx">
      <motion.div initial={{
      opacity: 0,
      y: 26
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.35
    }} transition={{
      duration: 0.65
    }} className="relative flex flex-col items-start gap-5 rounded-xl border border-gold/25 bg-panel p-6 sm:flex-row sm:items-center sm:gap-10 sm:p-10" data-id="element-188" data-mp="t7lmti4vmkek">
        <span aria-hidden="true" className="flex h-14 w-14 flex-shrink-0 animate-seal-pulse items-center justify-center rounded-full border-2 border-gold text-gold sm:h-20 sm:w-20" data-id="element-189" data-mp="1c5oe63kwctfj">
          <ShieldCheck className="h-7 w-7 sm:h-9 sm:w-9" data-id="element-190" data-mp="24miopsm5t43c" />
        </span>

        <div data-id="element-191" data-mp="24ntutz32unxm">
          <h3 className="font-display text-[1.3rem] font-bold text-bone sm:text-[1.9rem]" data-id="element-192" data-mp="1zvitqswlow3h">
            Garantía “Cero Riesgo” de 7 días
          </h3>
          <p className="mt-3 max-w-[38rem] text-[14.5px] leading-relaxed text-ash sm:mt-4 sm:text-[15px]" data-id="element-193" data-mp="2p9amxo15ft5k">
            Estamos tan seguros de que este arsenal cambiará tu juego visual, que
            si en los primeros 7 días sientes que no has recibido 10 veces el
            valor de tu inversión, te devolvemos cada centavo. Sin preguntas.
          </p>
          <p className="mt-4 font-display text-base italic text-gold sm:mt-5 sm:text-lg" data-id="element-194" data-mp="26hrl3kiv2l54">
            El riesgo es 100% nuestro.
          </p>
        </div>

        <motion.span initial={{
        opacity: 0,
        scale: 2.2,
        rotate: -18
      }} whileInView={{
        opacity: 1,
        scale: 1,
        rotate: -9
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.6,
        delay: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className="absolute -bottom-3 right-4 rounded border-[3px] border-double border-gold px-3 py-1 font-mono text-[10px] font-extrabold tracking-[0.14em] text-gold sm:right-10 sm:text-[12px]" data-id="element-195" data-mp="2bfayyjbncvwj">
          RIESGO: 0%
        </motion.span>
      </motion.div>
    </FilePage>;
}